/**
 * Statistics: Clicks per Value Added Step table with 1 row per v.a.s
 * @param {DataStore} store - storage
 * @param {object} translations - translations / wording
 * @param {Pagination} pagination - pagination
 * @param {object} colors - colour palette
 */

class ClicksPerValueAddedStep {
  constructor(args) {
    this.store = args.store;
    this.translations = args.translations;
    this.colors = args.colors;
    this.randomValuesFromArray = args.randomValuesFromArray;
    this.outerContainer = document.querySelector('.clicks-per-vas');
    this.chartCanvas = this.outerContainer.querySelector('canvas');
    this.chartData = {};

    this.initGraph();
    this.addEvents();
  }

  addEvents() {
    ['init', 'update'].map(eventType => {
      this.store.subscribe(eventType, e => {
        // if(!e.list.clicks) return;

        const data = e.completeList.clicks;

        data.forEach(click => {
          const vasId = click.global_value_added_step_id;
          const label = vasId ? this.translations.valueAddedSteps[vasId] : this.translations.unknown;

          if (typeof this.chartData[label] !== 'undefined') {
            this.chartData[label]++;
          } else {
            this.chartData[label] = 1;
          }
        });

        const numClicksTotal = Object.values(this.chartData).reduce((prev, curr) => {
          prev += curr
          return prev;
        }, 0);

        this.chartLabels = [];
        this.chartValues = [];

        Object.keys(this.chartData).map(label => {
          const pct = this.chartData[label] / numClicksTotal * 100;
          this.chartLabels.push(`${label} (${pct.toFixed(2)}%)`);
          this.chartValues.push(this.chartData[label]);
        });

        this.updateGraph();
      });
    });
  }

  initGraph() {
    let chartSettings = {
      type: 'pie',
      data: {
        datasets: [{
          data: [],
          backgroundColor: []
        }],
        labels: []
      },
      options: {
        bezierCurve: false,
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          display: true,
          position: 'top',
          labels: {
            boxWidth: 15,
            padding: 10,
            fontSize: 12
          }
        }
      }
    };

    this.chart = new Chart(this.chartCanvas, chartSettings);
  }

  updateGraph() {
    this.chart.data.datasets = [{
      data: this.chartValues,
      backgroundColor: this.randomValuesFromArray(this.colors, this.chartLabels.length)
    }];
    this.chart.data.labels = this.chartLabels;
    this.chart.update();
  }
}

export default ClicksPerValueAddedStep;